import React from "react";
import { Switch, InputLabel, Tooltip, Typography } from "@material-ui/core";
import { useField } from "formik";
import * as Icons from "@material-ui/icons";

import { checkFormValidity } from "../../../src/utils/helpers";
import { WorkflowErrors } from "../../contexts/WorkflowErrors";

export default function ({ label, ...props }) {
  const [field, meta, helper] = useField(props);

  const [taskErrors, setTaskErrors] = React.useContext(WorkflowErrors);

  React.useEffect(() => {
    // function to check the validity of the field
    checkFormValidity(field, meta, props, taskErrors, setTaskErrors);
  }, [field, meta, props]);

  const propsObj = { ...props };
  delete propsObj.taskReferenceName;

  return (
    <>
      {label}
      {propsObj.tooltip ? (
        <Tooltip title={propsObj.tooltip} arrow>
          <Icons.Help
            style={{
              verticalAlign: "middle",
              fontSize: "16px",
              marginLeft: "5px",
              marginBottom: "5px",
            }}
            color="primary"
          />
        </Tooltip>
      ) : null}
      <InputLabel />
      <Switch
        color="primary"
        checked={field.value}
        onChange={(e) => helper.setValue(e.target.checked)}
        {...propsObj}
      />
    </>
  );
}
